// NPM Imports
import React, { useEffect, useState } from "react";
import { Label, Input } from "../../../../revvComponents";

// Components Imports

// Actions Imports

// Internal Imports

// Destructuring

export default function RevvEditorCheckbox({
  isDisabled,
  option,
  isDefaultChecked,
  updateCheckboxField,
  checkboxId,
  isMagicLinkPage,
  isDocInFinalStage,
  isReadOnly,
  className,
  inputFieldStyles,
}) {
  // local states
  const [isChecked, handleCheckbox] = useState(isDefaultChecked);

  // CDM
  useEffect(() => {
    if (isDefaultChecked) {
      handleCheckbox(true);
    } else if (isChecked) {
      handleCheckbox(false);
    }
  }, [isDefaultChecked, isChecked]);

  const _handleCheckbox = value => {
    if (!isDisabled && !isDocInFinalStage && !isMagicLinkPage && !isReadOnly) {
      handleCheckbox(value);
      updateCheckboxField({ option, isChecked: value });
    }
  };

  if (isReadOnly) {
    if (isChecked) {
      className += " checked ";
    }
  }

  return (
    <span className={className} contentEditable={false}>
      <Label htmlFor={checkboxId}>
        <Input
          key={`${checkboxId}-${isChecked ? "checked" : "unchecked"}`}
          id={checkboxId}
          name={checkboxId}
          data-test={"revveditor-checkbox-input-field"}
          type={"checkbox"}
          checked={isChecked}
          onChange={() => _handleCheckbox(!isChecked)}
          disabled={isDisabled}
        />
        {option && (
          <span className="revveditor-checkbox-label" style={inputFieldStyles}>
            {option}
          </span>
        )}
      </Label>
    </span>
  );
}
